type TMeasure = 'Measures' | 'Recommendations';

const measuresTypes = {
  MEASURES: 'measures' as TMeasure,
  RECOMANDATIONS: 'recommendations' as TMeasure
};

export { measuresTypes };
export type { TMeasure };
